import {Link, useLocation} from "react-router-dom";
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import {navigation} from "@/config/navigation";
import * as m from "@/paraglide/messages";

export function SidebarNav() {
  const location = useLocation();

  return (
    <SidebarGroup>
      <SidebarGroupContent>
        <SidebarMenu>
          {navigation.map((item) => {
            const isActive = location.pathname === item.url;
            // Get localized title from messages
            const title =
              item.messageKey === "nav_main"
                ? m.nav_main()
                : item.messageKey === "nav_chat"
                  ? m.nav_chat()
                  : item.messageKey === "nav_influence_map"
                    ? m.nav_influence_map()
                    : item.messageKey === "nav_favorites"
                      ? m.nav_favorites()
                      : item.messageKey === "nav_dashboard"
                        ? m.nav_dashboard()
                        : item.title;

            return (
              <SidebarMenuItem key={item.url}>
                <SidebarMenuButton asChild isActive={isActive} tooltip={title}>
                  <Link to={item.url}>
                    <item.icon />
                    <span>{title}</span>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
            );
          })}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
